import createRootReducer from '../../reducers/apps/case-json';
import { thunk } from 'redux-thunk';
import logger from 'redux-logger';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import authMiddleware from '../../core/middleware/auth-middleware';
import { applyMiddleware, compose, createStore } from 'redux';

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const history = createBrowserHistory();
const rootReducer = createRootReducer(history);

const middlewares: any[] = [
  authMiddleware,
  routerMiddleware(history),
  thunk,
  !process.env.JEST_WORKER_ID && logger
].filter(Boolean);

const store = createStore(
  rootReducer, // root reducer with router state
  undefined,
  composeEnhancers(applyMiddleware(...middlewares))
);

//const store = buildStore(rootReducer, {router});

export { store, history };
